import React from 'react';
import {useHistory} from 'react-router-dom';

import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {EButtonType} from 'entities/metadata';

import {SimpleActionButton} from '../../components';

export interface IHistoryBackButtonProps {
    actionTitle?: string;
    actionIcon?: string;
    buttonType?: EButtonType;
    url?: string;

}

export const ButtonHistoryBack = (
    {
        actionTitle = 'Вернуться ко всем запросам', actionIcon, buttonType, url,
    }: IHistoryBackButtonProps,
) => {
    const history = useHistory();
    const handleClick = () => {
        if (url) {
            history.push(url);
            return;
        }
        history.go(-1);
    };
    return (
        <SimpleActionButton
            type={buttonType || 'text'}
            title={actionTitle}
            onClick={handleClick}
            icon={actionIcon as TIconType}
        />
    );
};
